import { CLEAR_NETWORK_BROWSE_GROUP_PROGRAMS } from 'actions';

export default function clearNetworkBrowseGroupPrograms() {
  return (dispatch) => (
    dispatch({ type: CLEAR_NETWORK_BROWSE_GROUP_PROGRAMS })
  );
}
